var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegionServer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99935 0.184898C3.19935 0.184898 0.666016 2.33156 0.666016 5.65157C0.666016 7.77156 2.29935 10.2649 5.55935 13.1382C5.81268 13.3582 6.19268 13.3582 6.44602 13.1382C9.69935 10.2649 11.3327 7.77156 11.3327 5.65157C11.3327 2.33156 8.79935 0.184898 5.99935 0.184898ZM5.99935 6.85157C5.26602 6.85157 4.66602 6.25157 4.66602 5.51823C4.66602 4.7849 5.26602 4.1849 5.99935 4.1849C6.73268 4.1849 7.33268 4.7849 7.33268 5.51823C7.33268 6.25157 6.73268 6.85157 5.99935 6.85157Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionServer);
export default __webpack_public_path__ + "static/media/region_server.1d3cd398463fe6e1b7c10f7aa26b5bc4.svg";
export { ForwardRef as ReactComponent };